import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { pexios } from '../../../utils/functions';

export default function ReportClientInfo({ report }) {

    const { t } = useTranslation();
    const [cars, setCars] = useState({
        culprit: {},
        losses: {},
    });
    const getElement = useCallback(async (data) => {
        let carData = {};
        const keys = ['type', 'brand', 'model', 'color'];
        const getElementApi = async(i) => {
            await pexios(`api/get_car_${keys[i]}_by_id`, 'post', { id: data[`car_${keys[i]}_id`] })
                .then(res => {
                    carData = { ...carData, [keys[i]]: res.data.name };
                });
        }
        for (let i = 0; i < 4; i++) {
            await getElementApi(i);
        }
        return carData;
    }, []);
    useEffect(() => {
        if (!report.id) return;
        getElement(report.culprit.car).then(res => setCars(prevState => ({...prevState, culprit: res})));
        if (report.accident.insurance_type === 'third' && report.losses.type === 'car')
            getElement(report.losses.car).then(res => setCars(prevState => ({...prevState, losses: res})));
    }, [report, getElement]);

    const accident = useMemo(() => report.accident, [report]);
    const culprit = useMemo(() => report.culprit, [report]);
    const losses = useMemo(() => report.losses, [report]);

    return (
        <>
            <div className='box'>
                <p className='title border-bottom pb5'>
                    {accident.insurance_type === 'third' ? t('Culprit info') : t('Losses info')}
                </p>
                <div className='textParent'>
                    <div className='text'>{t('Full name')}:</div>
                    <div
                        className='text text-left'>{culprit.user.full_name}</div>
                </div>
                <div className='textParent'>
                    <div className='text'>{t('Phone num')}:</div>
                    <div className='text text-left'>{culprit.user.mobile}</div>
                </div>
                <div className='textParent'>
                    <div className='text'>{t('Third insurance number')}:</div>
                    <div className='text text-left'>{culprit.third.insurance_number}</div>
                </div>
                {
                    accident.insurance_type === 'body' &&
                    <div className='textParent'>
                        <div className='text'>{t('Body insurance number')}:</div>
                        <div className='text text-left'>{culprit.body.insurance_number}</div>
                    </div>
                }
                <div className='textParent'>
                    <div className='text'>{t('Address')}:</div>
                    <div className='text text-left'>{accident.address}</div>
                </div>
                <div className='textParent'>
                    <div className='text'>{t('Vehicle type')}:</div>
                    <div className='text text-left'>{cars.culprit.type}</div>
                </div>
                <div className='textParent'>
                    <div className='text'>{t('Vehicle brand')}:</div>
                    <div className='text text-left'>{cars.culprit.brand}</div>
                </div>
                <div className='textParent'>
                    <div className='text'>{t('Vehicle model')}:</div>
                    <div className='text text-left'>{cars.culprit.model}</div>
                </div>
                <div className='textParent'>
                    <div className='text'>{t('Vehicle color')}:</div>
                    <div className='text text-left'>{cars.culprit.color}</div>
                </div>
            </div>
            {
                accident.insurance_type === 'third' &&
                <div className='box'>
                    <p className='title border-bottom pb5'>{t('Losses info')}</p>
                    {
                        losses.type === 'car' ?
                            <>
                                <div className='textParent'>
                                    <div className='text'>{t('Full name')}:</div>
                                    <div
                                        className='text text-left'>{losses.user.full_name}</div>
                                </div>
                                <div className='textParent'>
                                    <div className='text'>{t('Phone num')}:</div>
                                    <div className='text text-left'>{losses.user.mobile}</div>
                                </div>
                                <div className='textParent'>
                                    <div className='text'>{t('Third insurance number')}:</div>
                                    <div className='text text-left'>{losses.third.insurance_number}</div>
                                </div>
                                <div className='textParent'>
                                    <div className='text'>{t('Vehicle type')}:</div>
                                    <div className='text text-left'>{cars.losses.type}</div>
                                </div>
                                <div className='textParent'>
                                    <div className='text'>{t('Vehicle brand')}:</div>
                                    <div className='text text-left'>{cars.losses.brand}</div>
                                </div>
                                <div className='textParent'>
                                    <div className='text'>{t('Vehicle model')}:</div>
                                    <div className='text text-left'>{cars.losses.model}</div>
                                </div>
                                <div className='textParent'>
                                    <div className='text'>{t('Vehicle color')}:</div>
                                    <div className='text text-left'>{cars.losses.color}</div>
                                </div>
                            </> :
                            <>
                                <div className='textParent'>
                                    <div className='text'>{t('Owner name')}:</div>
                                    <div className='text text-left'>{losses.owner_name}</div>
                                </div>
                                <div className='textParent'>
                                    <div className='text'>{t('Owner type')}:</div>
                                    <div className='text text-left'>{losses.owner_type}</div>
                                </div>
                            </>
                    }
                </div>
            }
        </>
    );
}
